import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum WorkspaceColumn {
    NAME = "name",
    ENTITIES = "entities",
    TEAM = "team",
}

export enum WorkspaceSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    START_DATE_ASC = "START_DATE_ASC",
    START_DATE_DESC = "START_DATE_DESC",
    PLAN_ASC = "PLAN_ASC",
    PLAN_DESC = "PLAN_DESC",
    CREATED_AT_ASC = "CREATED_AT_ASC",
    CREATED_AT_DESC = "CREATED_AT_DESC",
    SUBSCRIPTION_START_DATE_ASC = "SUBSCRIPTION_START_DATE_ASC",
    SUBSCRIPTION_START_DATE_DESC = "SUBSCRIPTION_START_DATE_DESC",
    CLOSE_DATE_ASC = "CLOSE_DATE_ASC",
    CLOSE_DATE_DESC = "CLOSE_DATE_DESC",
    DUE_DATE_ASC = "DUE_DATE_ASC",
    DUE_DATE_DESC = "DUE_DATE_DESC",
    STAGE_ASC = "STAGE_ASC",
    STAGE_DESC = "STAGE_DESC",
    DAYS_IN_STAGE_ASC = "DAYS_IN_STAGE_ASC",
    DAYS_IN_STAGE_DESC = "DAYS_IN_STAGE_DESC",
    TASKS_COUNT_ASC = "TASKS_COUNT_ASC",
    TASKS_COUNT_DESC = "TASKS_COUNT_DESC",
    UNREAD_TASKS_COUNT_ASC = "UNREAD_TASKS_COUNT_ASC",
    UNREAD_TASKS_COUNT_DESC = "UNREAD_TASKS_COUNT_DESC",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceColumn.ENTITIES),
});
export type EntitiesColumn = z.infer<typeof EntitiesColumnSchema>;

const TeamColumnSchema = ColumnSchema.extend({
    id: z.literal(WorkspaceColumn.TEAM),
});
export type TeamColumn = z.infer<typeof TeamColumnSchema>;

export const WorkspaceViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.WORKSPACE),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            EntitiesColumnSchema,
            TeamColumnSchema,
        ]),
    ),
});

export type WorkspaceView = z.infer<typeof WorkspaceViewSchema>;
